var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipCamera24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#727981",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9C6.75 10.245 7.755 11.25 9 11.25C10.245 11.25 11.25 10.245 11.25 9C11.25 7.755 10.245 6.75 9 6.75C7.755 6.75 6.75 7.755 6.75 9Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.75C6 6.3375 5.6625 6 5.25 6H3.8175C4.8525 4.2075 6.7875 3 9 3C11.6175 3 13.8375 4.68 14.655 7.02C14.76 7.3125 15.0525 7.5 15.36 7.5C15.87 7.5 16.245 6.9975 16.08 6.5175C15.0525 3.5925 12.27 1.5 9 1.5C6.5475 1.5 4.365 2.685 3 4.5075V3.75C3 3.3375 2.6625 3 2.25 3C1.8375 3 1.5 3.3375 1.5 3.75V6.75C1.5 7.1625 1.8375 7.5 2.25 7.5H5.25C5.6625 7.5 6 7.1625 6 6.75Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.25C12 11.6625 12.3375 12 12.75 12H14.1825C13.1475 13.7925 11.2125 15 9.00001 15C6.38251 15 4.16251 13.32 3.34501 10.98C3.24001 10.6875 2.94751 10.5 2.64001 10.5C2.13001 10.5 1.75501 11.0025 1.92001 11.4825C2.94751 14.4075 5.73001 16.5 9.00001 16.5C11.4525 16.5 13.635 15.315 15 13.4925V14.25C15 14.6625 15.3375 15 15.75 15C16.1625 15 16.5 14.6625 16.5 14.25V11.25C16.5 10.8375 16.1625 10.5 15.75 10.5H12.75C12.3375 10.5 12 10.8375 12 11.25Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipCamera24Dp);
export default __webpack_public_path__ + "static/media/flip_camera__24dp.926e6070.svg";
export { ForwardRef as ReactComponent };